import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && user.role && user.role !== "customer") nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role === "customer") { toast.error("This account is not an admin."); setBusy(false); return; }
      nav("/admin");
    } catch (er) { toast.error(apiErr(er)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#1F191B] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <img src="/logo.png" alt="SHAROA" className="h-16 brightness-0 invert mx-auto" />
        <p className="text-[10px] uppercase tracking-[0.3em] text-sharoa-rose text-center mt-2 mb-8">Admin Portal</p>
        <form onSubmit={submit} className="bg-white p-8 space-y-4">
          <h1 className="font-serif text-2xl text-center">Sign In</h1>
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full border border-sharoa-line px-4 py-3 text-sm outline-none focus:border-sharoa-rose" />
          <button data-testid="admin-login-submit" disabled={busy} className="w-full bg-sharoa-rose text-white text-xs uppercase tracking-widest py-4">{busy ? "Signing in…" : "Sign In"}</button>
        </form>
      </div>
    </div>
  );
}
